import { ObjectId, Stored, StudentOpinion } from "../types";
import ApiModule from "./base";

export default class OpinionsModule extends ApiModule {
  constructor(baseURL: string) {
    super(baseURL, "opinions");
  }

  async create(
    opinion: Omit<Omit<StudentOpinion, "hidden">, "studentId">,
  ): Promise<Stored<StudentOpinion>> {
    const request = new Request(this.url, {
      method: "POST",
      headers: this._defaultHeaders(),
      body: JSON.stringify({ opinion }),
    });
    return await this._resolve(request);
  }

  async update(id: ObjectId, hidden: boolean): Promise<boolean> {
    const request = new Request(`${this.url}/${id}`, {
      method: "PATCH",
      headers: this._defaultHeaders(),
      body: JSON.stringify({ opinion: { hidden } }),
    });
    return await this._resolve(request);
  }
}
